const AUTH_BASE_URL = `/auth`;
const STUDENT_BASE_URL = `/student`;
const STUDENT_CLASS_BASE_URL = `/student/class`;
const TUTOR_BASE_URL = `/tutor`;
const TUTOR_CLASS_BASE_URL = `/tutor/class`;
const STORAGE_BASE_URL = `/storage`;
const STUDENT_NOTES_BASE_URL = `/student/notes`;
const TUTOR_NOTES_BASE_URL = `/tutor/notices`;
const ADMIN_BASE_URL = `/admin`;
const ADMIN_STUDENT_BASE_URL = `/admin/students`;
const ADMIN_TUTOR_BASE_URL = `/admin/tutors`;
const ADMIN_REQUEST_BASE_URL = `/admin/verification-requests`;
const PASS_PAPERS_BASE_URL = `/past-papers`;
const ADMIN_REVIEW_BASE_URL = `/admin/reviews`;
const EXAM_RESULTS_BASE_URL = `/results`;
const INSTITUTES_BASE_URL = `/institute`;
const ADMIN_INSTITUTES_BASE_URL = `/admin/institutes`;
const PAYMENT_BASE_URL = `/payment`;
const SUBSCRIPTION_BASE_URL = `/subscription`;
const PACKAGES_BASE_URL = `/packages`;
const GRADE_BASE_URL = `/grade`;
const ADMIN_GRADE_BASE_URL = `/admin/grade`;
const ADMIN_PAST_PAPERS_BASE_URL = `/admin/past-papers`;
const GOOGLE_BASE_URL = `/google`;



export const AUTH_ENDPOINTS = {
  LOGIN: `${AUTH_BASE_URL}/login`,
  REFRESH_TOKEN: `${AUTH_BASE_URL}/refresh-token`,
  REGISTER: `${AUTH_BASE_URL}/register`,
  RESET_PASSWORD: `${AUTH_BASE_URL}/reset-password`,
  GENERATE_PASSWORD_RESET_TOKEN: `${AUTH_BASE_URL}/generate-password-reset-code`,
  VERIFY_EMAIL: `${AUTH_BASE_URL}/verify-email`,
  VERIFY_EMAIL_BEFORE_CHANGE: `${AUTH_BASE_URL}/verify-email-before-change`,
  VERIFY_PASSWORD_RESET_TOKEN: `${AUTH_BASE_URL}/verify-reset-code`,
  GOOGLE_LOGIN: `${AUTH_BASE_URL}/google-login`,
  GOOGLE_SIGNUP: `${AUTH_BASE_URL}/google-signup`,
  TOTP_SETUP: `${AUTH_BASE_URL}/setup-totp`,
  TOTP_VERIFY: `${AUTH_BASE_URL}/verify-otp`,
  VERIFY_CURRENT_PASSWORD: `${AUTH_BASE_URL}/verify-current-password`,
  VERIFY_PASSWORD: `${AUTH_BASE_URL}/verify-password`,
  TOGGLE_TWO_FACTOR: `${AUTH_BASE_URL}/toggle-two-factor`,
  FETCH_ROLES: `${AUTH_BASE_URL}/roles`,
};

export const STUDENT_ENDPOINTS = {
  PROFILE_UPDATE: `${STUDENT_BASE_URL}/update-profile`,
  GET_PROFILE: `${STUDENT_BASE_URL}/`,
  UPDATE_EMAIL: `${STUDENT_BASE_URL}/email`,
  INVITE: `${STUDENT_BASE_URL}/invite/:email`,
  SCHEDULES: `${STUDENT_BASE_URL}/class-schedule`,
  PUBLIC_PROFILE: `${STUDENT_BASE_URL}/public/:studentId`,
  PUBLIC_ENROLLED_TUTORS: `${STUDENT_BASE_URL}/public/:studentId/enrolled-tutors`,
  PRE_DELETE_CHECK: `${STUDENT_BASE_URL}/pre-delete-check`,
  DELETE_ACCOUNT: `${STUDENT_BASE_URL}/delete-account`,
  GET_LIMITS: `${STUDENT_BASE_URL}/limits`,
};

export const TUTOR_ENDPOINTS = {
  GET_PROFILE: `${TUTOR_BASE_URL}/`,
  PROFILE_UPDATE: `${TUTOR_BASE_URL}/update-profile`,
  UPDATE_EMAIL: `${TUTOR_BASE_URL}/email`,
  INVITE: `${TUTOR_BASE_URL}/invite/:email`,
  PUBLIC_PROFILE: `${TUTOR_BASE_URL}/public/:tutorId`,
  TUTORS_PROFILES: `${TUTOR_BASE_URL}/list`,
  GET_AVAILABILITY: `${TUTOR_BASE_URL}/availability/:tutorId`,
  ADD_AVAILABILITY: `${TUTOR_BASE_URL}/availability`,
  CONNECT_CALENDAR: `${GOOGLE_BASE_URL}/url/:keycloakId`,
  GET_LIMITS: `${TUTOR_BASE_URL}/limits`,
  GET_BANK_INFO: `${TUTOR_BASE_URL}/bank-info`,
  UPDATE_BANK_INFO: `${TUTOR_BASE_URL}/bank-info`,
  RESET_CALENDAR_CONNECTION: `${GOOGLE_BASE_URL}/reset-connection/:keycloakId`,
  PRE_DELETE_CHECK: `${TUTOR_BASE_URL}/pre-delete-check`,
  DELETE_ACCOUNT: `${TUTOR_BASE_URL}/delete-account`,
};

export const STORAGE_ENDPOINTS = {
  UPLOAD_CERTIFICATES: `${STORAGE_BASE_URL}/upload-certifications`,
  UPLOAD_IDENTIFICATION: `${STORAGE_BASE_URL}/upload-verifications`,
  UPLOAD_PROFILE_IMAGE: `${STORAGE_BASE_URL}/upload-profile-image`,
  GET_SIGNED_URL: `${STORAGE_BASE_URL}/signed-url`,
  GET_SIGNED_PUBLIC_URL: `${STORAGE_BASE_URL}/signed-url-public`,
  // Past paper uploads live in PAPERS_ENDPOINTS — /storage/upload-past-papers is the legacy route
  // and produces files no paper document points at.
  UPLOAD_ACHIEVEMENTS: `${STORAGE_BASE_URL}/upload-achievements`,
};

export const STUDENT_CLASS_ENDPOINTS = {
  SCHEDULES: `${STUDENT_CLASS_BASE_URL}/schedule`,
  REQUEST_A_CLASS: `${STUDENT_CLASS_BASE_URL}/request`,
  CHECK_CONFLICTS: `${STUDENT_CLASS_BASE_URL}/request/conflict`,
  CHECK_CONFLICTS_OTHERS: `${STUDENT_CLASS_BASE_URL}/request/conflict/other-students`,
  FETCH_TO_BE_CONFIRMED: `${STUDENT_CLASS_BASE_URL}/confirmations`,
  ACCEPT_SCHEDULE: `${STUDENT_CLASS_BASE_URL}/confirmations/:classId/accept`,
  REJECT_SCHEDULE: `${STUDENT_CLASS_BASE_URL}/confirmations/:classId/reject`,
  ENROLLED_TUTORS: `${STUDENT_CLASS_BASE_URL}/tutors`,
  CLASSES_BY_TUTOR: `${STUDENT_CLASS_BASE_URL}/tutors/:tutorId/classes`,
  PREVIOUS_CLASSES_BY_TUTOR: `${STUDENT_CLASS_BASE_URL}/tutors/:tutorId/previous-classes`,
  CLASS_INSTANCE_DETAILS: `${STUDENT_CLASS_BASE_URL}/tutors/classes/:classInstanceId`,
  CREATE_REVIEW: `/reviews`,
  RESCHEDULE_CLASS: `${STUDENT_CLASS_BASE_URL}/reschedule`,
  ACCEPT_RESCHEDULE_REQUEST: `${STUDENT_CLASS_BASE_URL}/reschedule/:requestId/accept`,
  REJECT_RESCHEDULE_REQUEST: `${STUDENT_CLASS_BASE_URL}/reschedule/:requestId/reject`,
  UNCONFIRMED_COMPLETED_CLASSES: `${STUDENT_CLASS_BASE_URL}/instances/unconfirmed`,
  CONFIRM_COMPLETED_CLASS: `${STUDENT_CLASS_BASE_URL}/instances/:instanceId/confirm`,
  CANCEL_CLASS_INSTANCE: `${STUDENT_CLASS_BASE_URL}/instances/:instanceId/cancel`,
};

export const TUTOR_CLASS_ENDPOINTS = {
  REQUESTS: `${TUTOR_CLASS_BASE_URL}/requests`,
  CREATE_SCHEDULED_CLASS: `${TUTOR_CLASS_BASE_URL}/requests/schedule-class`,
  GET_REQUEST: `${TUTOR_CLASS_BASE_URL}/requests/:classId`,
  SCHEDULE_CLASS: `${TUTOR_CLASS_BASE_URL}/requests/:classId/schedule`,
  REJECT_REQUEST: `${TUTOR_CLASS_BASE_URL}/requests/:classId/reject`,
  VERIFICATION_CALL_STATUS: `${TUTOR_CLASS_BASE_URL}/requests/:classId/verification`,
  FETCH_SCHEDULES: `${TUTOR_CLASS_BASE_URL}/schedule`,
  ENROLLED_STUDENTS: `${TUTOR_CLASS_BASE_URL}/students`,
  SEND_VERIFICATION_CALL: `${TUTOR_CLASS_BASE_URL}/requests/:classId/verification-email`,
  END_CLASSES: `${TUTOR_CLASS_BASE_URL}/students/:studentId/classes`,
  STUDENT_CLASSES: `${TUTOR_CLASS_BASE_URL}/students/:studentId/classes`,
  STUDENT_PAST_CLASSES: `${TUTOR_CLASS_BASE_URL}/students/:studentId/previous-classes`,
  CLASS_INSTANCE_DETAILS: `${TUTOR_CLASS_BASE_URL}/students/classes/:classInstanceId`,
  GET_STUDENT_REVIEWS: `/reviews/:tutorId`,
  PUBLIC_CLASS_SCHEDULE: `${TUTOR_CLASS_BASE_URL}/public/schedule/:tutorId`,
  RESCHEDULE_REQUEST_DETAILS: `${TUTOR_CLASS_BASE_URL}/reschedule/:requestId`,
  ACCEPT_RESCHEDULE_REQUEST: `${TUTOR_CLASS_BASE_URL}/reschedule/:requestId/accept`,
  REJECT_RESCHEDULE_REQUEST: `${TUTOR_CLASS_BASE_URL}/reschedule/:requestId/reject`,
  CREATE_RESCHEDULE_REQUEST: `${TUTOR_CLASS_BASE_URL}/reschedule`,
  UNCONFIRMED_CLASSES: `${TUTOR_CLASS_BASE_URL}/instances/unconfirmed`,
  CONFIRM_CLASS: `${TUTOR_CLASS_BASE_URL}/instances/:instanceId/confirm`,
  CANCEL_CLASS_INSTANCE: `${TUTOR_CLASS_BASE_URL}/instances/:instanceId/cancel`,
};

export const STUDENT_NOTE_ENDPOINTS = {
  CREATE: `${STUDENT_NOTES_BASE_URL}/`,
  LIST: `${STUDENT_NOTES_BASE_URL}/`,
  DELETE: `${STUDENT_NOTES_BASE_URL}/:noteId`,
  UPDATE: `${STUDENT_NOTES_BASE_URL}/:noteId`,
  CHECK_LIMIT: `${STUDENT_NOTES_BASE_URL}/check-limit`,
  AI_SUMMARY: `${STUDENT_NOTES_BASE_URL}/class-summaries`,
  AI_TRANSCRIPT: `${STUDENT_NOTES_BASE_URL}/class-transcripts`,
};

export const TUTOR_NOTE_ENDPOINTS = {
  CREATE: `${TUTOR_NOTES_BASE_URL}/`,
  LIST: `${TUTOR_NOTES_BASE_URL}/`,
  PUBLISHED: `${TUTOR_NOTES_BASE_URL}/published/:tutorId`,
  DELETE: `${TUTOR_NOTES_BASE_URL}/:noticeId`,
  UPDATE: `${TUTOR_NOTES_BASE_URL}/:noticeId`,
  CHECK_LIMIT: `${TUTOR_NOTES_BASE_URL}/check-limit`,
};

// Admin Student End Points
export const ADMIN_STUDENT_ENDPOINTS = {
  GET_STUDENTS: `${ADMIN_STUDENT_BASE_URL}/`,
  SEARCH_STUDENTS: `${ADMIN_STUDENT_BASE_URL}/`,
  UPDATE_STATUS: `${ADMIN_STUDENT_BASE_URL}/:studentId/status`,
  EXPORT_STUDENTS: `${ADMIN_STUDENT_BASE_URL}/export`,
  DELETE_STUDENTS: `${ADMIN_STUDENT_BASE_URL}/`,
  GET_STUDENT_PROFILE: `${ADMIN_STUDENT_BASE_URL}/:studentId`,
  GET_STUDENT_DETAILS: `${ADMIN_STUDENT_BASE_URL}/:studentId/details`,
  GET_ENROLLED_TUTORS: `${ADMIN_STUDENT_BASE_URL}/:studentId/tutors`,
  GET_PREVIOUS_TUTORS: `${ADMIN_STUDENT_BASE_URL}/:studentId/previous-classes`,
};

// Admin Tutor End Points
export const ADMIN_TUTOR_ENDPOINTS = {
  GET_TUTORS: `${ADMIN_TUTOR_BASE_URL}/`,
  SEARCH_TUTORS: `${ADMIN_TUTOR_BASE_URL}/`,
  UPDATE_STATUS: `${ADMIN_TUTOR_BASE_URL}/:tutorId/status`,
  EXPORT_TUTORS: `${ADMIN_TUTOR_BASE_URL}/export`,
  DELETE_TUTORS: `${ADMIN_TUTOR_BASE_URL}/`,
  GET_TUTOR_PROFILE: `${ADMIN_TUTOR_BASE_URL}/:tutorId`,
  GET_ENROLLED_STUDENTS: `${ADMIN_TUTOR_BASE_URL}/:tutorId/students `,
  GET_PREVIOUS_STUDENTS: `${ADMIN_TUTOR_BASE_URL}/:tutorId/previous-classes`,
  GET_PAYOUT_SUMMARY: `${ADMIN_TUTOR_BASE_URL}/payouts/summary`,
  GET_PAYOUT_HISTORY: `${ADMIN_TUTOR_BASE_URL}/payouts/history/:tutorId`,
};

// Admin Institute End Points
export const ADMIN_INSTITUTE_ENDPOINTS = {
  GET_INSTITUTES: `${ADMIN_INSTITUTES_BASE_URL}/`,
  SEARCH_INSTITUTES: `${ADMIN_INSTITUTES_BASE_URL}/`,
  UPDATE_STATUS: `${ADMIN_INSTITUTES_BASE_URL}/:instituteId/status`,
  EXPORT_INSTITUTES: `${ADMIN_INSTITUTES_BASE_URL}/export`,
  DELETE_INSTITUTES: `${ADMIN_INSTITUTES_BASE_URL}/`,
  GET_INSTITUTES_PROFILE: `${ADMIN_INSTITUTES_BASE_URL}/:instituteId `,
  GET_ENROLLED_TUTORS: `${ADMIN_INSTITUTES_BASE_URL}/:instituteId/tutors `,
}

// Admin Tutor Verification Request End Points
export const ADMIN_VERIFICATION_REQUEST_ENDPOINTS = {
  GET_REQUESTS: `${ADMIN_REQUEST_BASE_URL}/`,
  APPROVE_VERIFICATION_REQUEST: `${ADMIN_REQUEST_BASE_URL}/:tutorId/accept`,
  REJECT_VERIFICATION_REQUEST: `${ADMIN_REQUEST_BASE_URL}/:tutorId/reject`,
  GET_TUTOR_PROFILE: `${ADMIN_REQUEST_BASE_URL}/:tutorId `,
  UPDATE_INITIAL_REVIEW: `${ADMIN_REQUEST_BASE_URL}/:tutorId/initial-review`,
  UPDATE_DOCUMENT_VERIFICATION: `${ADMIN_REQUEST_BASE_URL}/:tutorId/document-verification`,
  UPDATE_BACKGROUND_CHECK: `${ADMIN_REQUEST_BASE_URL}/:tutorId/background-check`,
  UPDATE_FINAL_REVIEW: `${ADMIN_REQUEST_BASE_URL}/:tutorId/final-review`,
  EXPORT_REQUESTS: `${ADMIN_REQUEST_BASE_URL}/export`,
};

//Admin User End Points
export const ADMIN_USER_ENDPOINTS = {
  GET_USERS: `${ADMIN_BASE_URL}/list`,
  GET_ADMIN: `${ADMIN_BASE_URL}/:adminId`,
  UPDATE_ADMIN_USERNAME: `${ADMIN_BASE_URL}/:adminId/username`,
  UPDATE_ADMIN_EMAIL: `${ADMIN_BASE_URL}/:adminId/email`,
  UPDATE_ADMIN_ROLE: `${ADMIN_BASE_URL}/:adminId/role`,
  UPDATE_ADMIN_STATUS: `${ADMIN_BASE_URL}/:adminId/status`,
  UPDATE_ADMIN_PASSWORD: `${ADMIN_BASE_URL}/:adminId/password`,
  DELETE_ADMIN: `${ADMIN_BASE_URL}/:adminId`,
};

//Admin Settings End Points
export const ADMIN_SETTINGS_ENDPOINTS = {
  UPDATE_ADMIN_USERNAME: `${ADMIN_BASE_URL}/username`,
  UPDATE_ADMIN_EMAIL: `${ADMIN_BASE_URL}/email `,
  UPDATE_ADMIN_PASSWORD: `${ADMIN_BASE_URL}/password`,
};

export const PAPERS_ENDPOINTS = {
  FETCH: `${PASS_PAPERS_BASE_URL}/`,
  FILTERS: `${PASS_PAPERS_BASE_URL}/filters`,
  BY_GRADE: `${PASS_PAPERS_BASE_URL}/by-grade`,
  DOWNLOAD_FILE: `${PASS_PAPERS_BASE_URL}/:paperId/files/:fileId/download`,

  ADMIN_LIST: ADMIN_PAST_PAPERS_BASE_URL,
  ADMIN_CREATE: ADMIN_PAST_PAPERS_BASE_URL,
  ADMIN_BULK_CREATE: `${ADMIN_PAST_PAPERS_BASE_URL}/bulk`,
  ADMIN_UPDATE: `${ADMIN_PAST_PAPERS_BASE_URL}/:id`,
  ADMIN_DELETE: `${ADMIN_PAST_PAPERS_BASE_URL}/:id`,
  ADMIN_ADD_FILES: `${ADMIN_PAST_PAPERS_BASE_URL}/:id/files`,
  ADMIN_DELETE_FILE: `${ADMIN_PAST_PAPERS_BASE_URL}/:id/files/:fileId`,
};

//Admin Student Reviews End Points
export const ADMIN_STUDENT_REVIEWS_ENDPOINTS = {
  GET_REVIEWS: `${ADMIN_REVIEW_BASE_URL}/`,
  GET_REVIEW_DETAILS: `${ADMIN_REVIEW_BASE_URL}/:reviewId  `,
  UPDATE_REVIEW: `${ADMIN_REVIEW_BASE_URL}/:reviewId `,
  EXPORT_REVIEWS: `${ADMIN_REVIEW_BASE_URL}/export`,
};

export const EXAM_RESULT_ENDPOINTS = {
  GET_ALL: `${EXAM_RESULTS_BASE_URL}/all`,
  GET_ALL_BY_STUDENT: `${EXAM_RESULTS_BASE_URL}/all/:studentId`,
  GET_DETAILS: `${EXAM_RESULTS_BASE_URL}/:resultId`,
  CREATE: `${EXAM_RESULTS_BASE_URL}/:studentId`,
  UPDATE: `${EXAM_RESULTS_BASE_URL}/:resultId`,
  DELETE: `${EXAM_RESULTS_BASE_URL}/:resultId`,
};

export const INSTITUTE_ENDPOINTS = {
  GET_TUTORS: `${INSTITUTES_BASE_URL}/tutors`,
  CREATE_TUTORS: `${INSTITUTES_BASE_URL}/tutors`,
  GET_PENDING_TUTORS: `${INSTITUTES_BASE_URL}/pending-tutors`,
  DELETE_PENDING_TUTOR: `${INSTITUTES_BASE_URL}/pending-tutors/:tutorId`,
  UPDATE_ACCOUNT: `${INSTITUTES_BASE_URL}/update-profile`,
  UPDATE_USERNAME: `${INSTITUTES_BASE_URL}/username`,
  GET_PROFILE: `${INSTITUTES_BASE_URL}/`,
  GET_STUDENTS: `${INSTITUTES_BASE_URL}/students`,
  GET_PENDING_STUDENTS: `${INSTITUTES_BASE_URL}/pending-students`,
  DELETE_PENDING_STUDENT: `${INSTITUTES_BASE_URL}/pending-students/:studentId`,
  CREATE_STUDENT: `${INSTITUTES_BASE_URL}/students`,
  PRE_DELETE_CHECK: `${INSTITUTES_BASE_URL}/pre-delete-check`,
  DELETE_ACCOUNT: `${INSTITUTES_BASE_URL}/delete-account`,
}

export const PAYMENT_ENDPOINTS = {
  PAYHERE_SANDBOX_URL: 'https://sandbox.payhere.lk/pay/checkout',
  PAYHERE_LIVE_URL: 'https://www.payhere.lk/pay/checkout',
  PAYHERE_SANDBOX_PREAPPROVE_URL: 'https://sandbox.payhere.lk/pay/preapprove',
  PAYHERE_LIVE_PREAPPROVE_URL: 'https://www.payhere.lk/pay/preapprove',
  INITIATE: `${PAYMENT_BASE_URL}/initiate`,
  TOKENIZE: `${PAYMENT_BASE_URL}/tokenize`,
  MY_TOKEN: `${PAYMENT_BASE_URL}/my-token`,
  SUCCESS: `${PAYMENT_BASE_URL}/success`,
  FAILED: `${PAYMENT_BASE_URL}/failed`,
  PENDING: `${PAYMENT_BASE_URL}/pending`,
}

export const PACKAGES_ENDPOINTS = {
  GET_ALL: PACKAGES_BASE_URL,
}

export const SUBSCRIPTION_ENDPOINTS = {
  SUBSCRIBE: `${SUBSCRIPTION_BASE_URL}/subscribe`,
  MY: `${SUBSCRIPTION_BASE_URL}/my`,
  CHANGE_PACKAGE: `${SUBSCRIPTION_BASE_URL}/change-package`,
  CHANGE_PREVIEW: `${SUBSCRIPTION_BASE_URL}/change-preview`,
  CANCEL: `${SUBSCRIPTION_BASE_URL}/cancel`,
  CANCEL_PENDING: `${SUBSCRIPTION_BASE_URL}/pending`,
}

export const GRADE_MANAGEMENT_ENDPOINTS = {
    GET_ALL: `${GRADE_BASE_URL}/`,
}

export const ADMIN_GRADE_MANAGEMENT_ENDPOINTS = {
  GET_ALL: `${ADMIN_GRADE_BASE_URL}/`,
  CREATE: `${ADMIN_GRADE_BASE_URL}/`,
  UPDATE: `${ADMIN_GRADE_BASE_URL}/:gradeId`,
  DELETE: `${ADMIN_GRADE_BASE_URL}/`,
  DELETE_SUBJECT: `${ADMIN_GRADE_BASE_URL}/:gradeId/subject/remove`,
  EXPORT_GRADES: `${ADMIN_GRADE_BASE_URL}/export`,
}

export const CLASS_PAYMENT_ENDPOINTS = {
  SESSION_DETAILS: `/class-payment/session-details/:classInstanceId`,
  PAY: `/class-payment/pay`,
  STATUS: `/class-payment/:classInstanceId`,
}

export const DISCOUNT_ENDPOINTS = {
  APPLY: `/discounts/apply`,
}

export const ADMIN_DISCOUNT_ENDPOINTS = {
  GET_ALL: `/discounts/admin/all`,
  CREATE: `/discounts/admin/create`,
  UPDATE: `/discounts/admin/update/:id`,
  TOGGLE: `/discounts/admin/toggle/:id`,
}

export const CONTACT_ENDPOINTS = {
  SEND: `/contact/send`,
};